<template>
    <div>
        <v-footer
        app
        class="d-flex justify-center"
        style="background-color: #ed6103; margin: 0px;"
        >
            <div class="mod-footer">
                <div class="mod-footer__contents">
                    <nav class="mod-footer__helpfulLink">
                        <ul class="mod-footer__linkList">
                            <li class="mod-footer__linkListItem"><a href="https://www.homes.co.jp/about/concept/">LIFULL HOME'Sとは</a></li>
                            <li class="mod-footer__linkListItem"><a href="https://lifull.secure.force.com/inquiryform/homes/feedback" target="_blank" rel="noopener">ご意見・ご要望</a></li>
                            <li class="mod-footer__linkListItem"><a href="https://www.homes.co.jp/about/service/safetypolicy/">情報精度No.1への取り組み</a></li>
                            <li class="mod-footer__linkListItem"><a href="https://f.msgs.jp/webapp/wish/org/showEnquete.do?enqueteid=1&amp;clientid=13723&amp;databaseid=vhu" rel="noopener nofollow" target="_blank">掲載物件に関するお問合せ</a></li>
                            <li class="mod-footer__linkListItem"><a href="https://www.homes.co.jp/kiyaku/">サービス利用規約</a></li>
                            <li class="mod-footer__linkListItem"><a href="https://www.homes.co.jp/disclaimer/">免責事項</a></li>
                            <li class="mod-footer__linkListItem"><a href="https://LIFULL.com/privacy/" target="_blank" rel="noopener">個人情報</a></li>
                            <li class="mod-footer__linkListItem"><a href="http://recruit.LIFULL.com/" target="_blank" rel="noopener">スタッフ募集</a></li>
                            <li class="mod-footer__linkListItem"><a href="https://LIFULL.com/" target="_blank" rel="noopener">運営会社</a></li>
                        </ul>
                    </nav>
                    <div class="mod-footer__companyIdentity">
                        <p class="mod-footer__logo">
                            <img :src="`${lifull_white}?v=1fc357ee839713271fb3984ab881310d`" alt="LIFULL">
                            </p>
                        <p class="mod-footer__copyright">Copyright &copy; LIFULL Co., Ltd. All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </v-footer>
    </div>
</template>

<script>
import lifull_white from '../assets/lifull_white.svg';
export default {
  data(){
    return{
      lifull_white
    }
  }
}
</script>

<style scoped>
li{
  list-style: none;
}
.v-application p{
    margin-bottom: 0px !important;
}
.v-footer--fixed {
    position: static;
    font-family: "LIFULLFONT-Regular", "游ゴシック体", "YuGothic", "游ゴシック",
    "Yu Gothic", "メイリオ", "Meiryo", sans-serif !important;
}
.mod-footer {
  font-size: 16px;
  color: #fff;
  background-color: #ed6103;
}
.mod-footer__contents {
  position: relative;
  font-weight: bold;
}
@media only screen and (min-width: 769px) {
  .mod-footer__contents {
    max-width: 972px;
    margin: 0 auto;
    padding: 20px 16px;
    box-sizing: border-box;
  }
}
.mod-footer__linkList {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.mod-footer__linkListItem {
  border-bottom: 1px solid #fff;
  box-sizing: border-box;
  width: 50%;
}
.mod-footer__linkListItem:nth-of-type(even) {
  border-left: 1px solid #fff;
}
.mod-footer__linkListItem:nth-of-type(odd):last-child {
  width: 100%;
}
.mod-footer__linkListItem a {
  display: block;
  padding: 20px 11px;
  font-size: 13px;
  color: #fff;
  line-height: 1.3;
  text-decoration: none;
}
.mod-footer__linkListItem a:hover {
  color: #ffe680;
}
.mod-footer__companyIdentity {
  text-align: center;
  padding: 10px 25px;
}
@media only screen and (min-width: 769px) {
  .mod-footer__companyIdentity {
    margin-top: 20px;
    padding: 0;
  }
}
.mod-footer__logo {
  padding-bottom: 10px;
}
.mod-footer__logo img {
  display: inline-block;
  width: 212px;
}
.mod-footer__copyright {
  font-size: 12px;
  line-height: 1;
}
@media only screen and (min-width: 769px) {
  .mod-footer__copyright {
    text-align: right;
  }
}
@media only screen and (min-width: 769px) {
  .mod-footer__linkList {
    display: block;
    text-align: right;
  }
  .mod-footer__linkListItem {
    width: auto;
    display: inline-block;
    margin: 5px 0;
    padding: 0 10px;
    border-bottom: 0;
    line-height: 1;
  }
  .mod-footer__linkListItem + .mod-footer__linkListItem {
    border-left: 1px solid #fff;
  }
  .mod-footer__linkListItem:nth-of-type(odd):last-child {
    width: auto;
  }
  .mod-footer__linkListItem a {
    display: inline;
    padding: 0;
  }
  .mod-footer__logo {
    position: absolute;
    top: 8px;
    left: 5px;
  }
  .mod-footer__logo img {
    width: 212px;
  }
  .mod-footer__helpfulLink {
    margin-left: 210px;
    margin-right: -10px;
  }
}
.v-application ol, .v-application ul {
    padding-left: 0px !important;
}
.v-footer {
    padding: 0px !important;
}
.v-footer img{
  vertical-align: bottom;
}
</style>